var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error.ssr)?_c('be-dynamic',{attrs:{"page":_vm.error.ssr.pageContent.page,"content":_vm.error.ssr.pageContent.content,"type":_vm.error.ssr.backendLayout}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }